

const state = () => ({
    roles: [],
})

export default state